/* global window */
import isBotFast from 'isbot-fast';
const WITH_IS_BOT = 'WITH_IS_BOT';
export default function isBot() {
  return async ctx => {
    if (!ctx.__middleware.WITH_IS_BOT) {
      try {
        // assert isBot on server user agent header or client userAgent
        ctx.data.isBot = isBotFast(ctx.req ? ctx.req.headers['user-agent'] : window.navigator.userAgent);
      } catch (err) {
        // if there is an error asserting the bot then we default to false
        ctx.data.isBot = false;
      }
      ctx.registerMiddleware(WITH_IS_BOT);
    }
  };
}